import { useFormDeliveryTypeCategoryValue } from '@/features/pos/components/OrderFinalization/form'
import { AutomaticContainerSettingsQuery } from '@/features/pos/components/OrderFinalization/queries'
import { convertDeliveryTypeCategoryToApi } from '@/features/pos/components/OrderFinalization/utils/conversions'
import { useHandleQueryErrorWithToast } from '@/features/pos/hooks/useHandleQueryErrorWithToast'
import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

export interface AutomaticContainerSetting {
    ready: boolean
    shouldAttach: boolean
}

export const useShouldAttachAutomaticContainers = (): AutomaticContainerSetting => {
    const deliveryTypeCategory = useFormDeliveryTypeCategoryValue()
    const { data, error, loading } = useQuery(AutomaticContainerSettingsQuery, {
        fetchPolicy: 'cache-and-network',
    })

    useHandleQueryErrorWithToast(error, loading)

    return useMemo(() => {
        const selectedDeliveryTypeCategory =
            deliveryTypeCategory && convertDeliveryTypeCategoryToApi(deliveryTypeCategory)
        const setting = data?.automaticContainerSettings.find(
            ({ deliveryTypeCategory }) => deliveryTypeCategory === selectedDeliveryTypeCategory
        )

        return {
            ready: !!data && !!selectedDeliveryTypeCategory,
            shouldAttach: setting?.attachAutomatically ?? false,
        }
    }, [data, deliveryTypeCategory])
}
